import PageContainer from '@/common/components/PageContainer'
import TransactionSettingListing from '@/modules/client-setting/components/TransactionSetting/components/TransactionSettingListing'
import Spinner from '@/common/components/Spinner'
import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function TransactionSettingPage() {
	const { data: generalSetting, isLoading } = useQueryGetGeneralSetting()

	if (isLoading || !generalSetting) {
		return <Spinner />
	}

	return (
		<PageContainer>
			<TransactionSettingListing data={generalSetting} />
		</PageContainer>
	)
}

const GuardedTransactionSettingPage = withUserPermission(
	TransactionSettingPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.WEB_SETTING],
	},
)

export default GuardedTransactionSettingPage
